var React = require('react');

function SalesContactTriangle (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M71.7927 70.9774L72.1352 16.0645L139.167 69.1138L71.7927 70.9774Z","fill":"#6C21E4","key":0}),React.createElement("path",{"d":"M23.2897 96.9822L72.2176 16.0184L71.8492 70.8633L23.2897 96.9822Z","fill":"#651DD8","key":1}),React.createElement("path",{"d":"M23.2969 96.9834L71.8221 70.8829L139.174 69.1131L23.2969 96.9834Z","fill":"#5915C7","key":2})]);
}

SalesContactTriangle.defaultProps = {"width":"140","height":"124","viewBox":"0 0 140 124","fill":"none"};

module.exports = SalesContactTriangle;

SalesContactTriangle.default = SalesContactTriangle;
